import React from 'react';

interface RadioGroupProps {
  name: string;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string; }[];
}

export function RadioGroup({ name, value, onChange, options }: RadioGroupProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className="flex gap-4">
      {options.map(option => (
        <label key={option.value} className="flex items-center">
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={handleChange}
            className="mr-2 accent-[var(--accent-color)]"
          />
          <span className="text-sm">{option.label}</span>
        </label>
      ))}
    </div>
  );
}